import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'htmlParse'
})
export class HtmlParsePipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: string, ...args: unknown[]): SafeHtml {
    if (!value) return '';

    let cleanValue = value
    .replace(/<\/?p[^>]*>/gi, '')
    .replace(/<\/?div[^>]*>/gi, '')

    return this._sanitizer.bypassSecurityTrustHtml(cleanValue)
  }

}
